import { Component, OnInit } from '@angular/core';
import { LoginService } from '@app/services/login.service';
import { ValidaDocumento } from '@app/utils/valida-documento';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html'
})
export class RecuperarSenhaComponent implements OnInit {

  validaDocumento: ValidaDocumento = new ValidaDocumento();
  producao: boolean = false;
  carregando: boolean = false;
  email: string = '';

  constructor(
    private loginService: LoginService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    if (environment.PRODUCAO) {
      this.producao = true;
    }
  }

  onSubmit() {
    if (!this.validaDocumento.validaEmail(this.email?.trim())) {
      this.toastr.error('Insira um e-mail válido!');
      return;
    }

    this.carregando = true;
    this.loginService.recuperarSenha(this.email).subscribe(
      () => {
        this.toastr.success("Link enviado!");
        this.carregando = false;
      },
      () => {
        this.toastr.error("Usuário não encontrado!");
        this.carregando = false;
      }
    );
  }

}
